
import React, { useState, useEffect, useRef  } from 'react'
import './edit.scss'
import Sidebar from '../../../components/sidebar/Sidebar'
import Navbar from '../../../components/navbar/Navbar'
import {serverTimestamp, collection, addDoc, doc, getDoc, updateDoc} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import { useNavigate, useParams } from "react-router-dom"
import { TextField, Button } from '@mui/material';

import Box from '@mui/material/Box';


const New = () => {

  const [isloading, setIsloading ] = useState(false)

  const today = new Date().toDateString()

  const [announcement, setAnnouncement] = useState("")

  const [errorAnnouncement, setErrorAnnouncement] = useState(false)

  const navigate = useNavigate();
  
  const {announcementId} = useParams()



const getAnnouncement = async() => {

    const docRef = doc(db, "announcement", announcementId);

    const docSnap = await getDoc(docRef);

        
    if (docSnap.exists()) {

      setAnnouncement(docSnap.data().Description)

    } else {
      
      console.log("No such document!");
    }


}


useEffect(()=>{

  getAnnouncement()

}, [])



    
    const handleUpdateAnnouncement = async(e) => {
  
      e.preventDefault()

      if(announcement === ""){
        
        return setErrorAnnouncement("This field is required")
      }

      setIsloading(true)

      try {

          await updateDoc(doc(db, "announcement", announcementId), {
  
              Description: announcement,
              createdAt: today,
    
          })

             setIsloading(false)

             navigate("/announcement")


        
      } catch (error) {
        
        console.log(error);
        
      }


  
    }

 

  return (
  <div className="new">
        {/* {isloading && <Spinner />} */}
        <Sidebar/>
        <div className="newContainer">
        <Navbar/>
          <div className='top'>
            <div className='topLeft'><h1>Edit Announcement</h1></div>
            
            <div className='topRight'>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/">
                Home
              </Link>
              <Link
                underline="hover"
                color="inherit"
                href="/announcement"
              >
                Announcement List
              </Link>
              <Typography color="green">Edit Announcement</Typography>
            </Breadcrumbs>
            </div>
          </div>
          <div className='bottom'>
         
            <div className='right'>
              <div className='form' onSubmit={handleUpdateAnnouncement}>
  
            
                  <TextField
                    id="announcement" 
                    value={announcement}
                    multiline
                    minRows={3}
                    maxRows={10}
                    placeholder="Enter Announcement (Not more than 12 Words)"
                    style={{width:'50%'}}
                    onChange={(e) => setAnnouncement(e.target.value)}
                  />
  
                  {
                    errorAnnouncement &&
  
                     <p style={{color:'red', fontSize:12}}>This field is required</p>
  
                  }
                
  
  
                <Button onClick={handleUpdateAnnouncement} disabled={isloading} style={{width:'50%', backgroundColor:'rgb(15, 31, 175)'}}>{isloading ? "...updating Announcement": 'Update Announcement'}</Button>
  
               {/* <button disabled={perc !== null && perc < 100} type='submit' >Submit</button> */}
  
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default New

















// import React, { useState } from 'react'
// import Sidebar from '../../../components/sidebar/Sidebar'
// import Navbar from '../../../components/navbar/Navbar'
// import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
// import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
// import { useEffect } from 'react';
// import Typography from '@mui/material/Typography';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
// import { collection, addDoc, serverTimestamp, doc, getDoc,  } from "firebase/firestore";
// import { useNavigate,  useParams } from "react-router-dom"
// import { auth, db, storage } from '../../../firebase'



// const Edit = ({inputs, title}) => {

//   // const [file, setFile ] = useState("")
//   const [ data, setData ] = useState({})
//   // const [ perc, setPerc ] = useState(null)
//   const [ isloading, setIsloading ] = useState(false)

//   const [charges, setCharges] = useState([])

//   const navigate = useNavigate();

// //   const params = useParams()
//   const {chargeId} = useParams()

// //   console.log("charge Id: ", chargeId)


//   const Spinner = () => {
//     return(
//       <span className='spinner-container'>
//           <span className='loading-spinner'></span>
//       </span>
//     )
//   }

//   const getCharge = async() => {

//     const docRef = doc(db, "charges", chargeId);

//     const docSnap = await getDoc(docRef);

        
//     if (docSnap.exists()) {

//       setCharges(docSnap.data() )

//     } else {
      
//       console.log("No such document!");
//     }


// }

// console.log('charges: ',charges)



 

// useEffect(()=>{

//   getCharge()

// }, [])


  


//   const handleInput = (e) =>{
//     const id = e.target.id;
//     const value = e.target.value;

//     setData({...charges, [id]:charges.id})
//   }

  
//   const handleAdd = async(e) => {

//     e.preventDefault()
//     setIsloading(true)

//     try{
       
       
//        await addDoc(collection(db, "charges"), {
//         ...data, charges : 'visaCharges',
//         timeStamp: serverTimestamp(),
        

//       });
      
//       setIsloading(false)

//       navigate('/charges')
      
      
//     }catch (err) {
//       console.log(err);
//     } 

//   }
// console.log(charges)
//   return (
//     <div className="new">
//       <Sidebar/>
//       <div className="newContainer">
//       <Navbar/>
//         <div className='top'>
//         <div className='topLeft'><h1>{title}</h1></div>
          
//           <div className='topRight'>
//           <Breadcrumbs aria-label="breadcrumb">
//             <Link underline="hover" color="inherit" href="/">
//               Home
//             </Link>
//             <Link
//               underline="hover"
//               color="inherit"
//               href="/charges"
//             >
//               Charges List
//             </Link>
//             <Typography color="green">Add Charges</Typography>
//           </Breadcrumbs>
//           </div>
//         </div>
        
//         <div className='bottom'>
        
//           <div className='right'>
//             <form onSubmit={handleAdd}>

//                 <div className='formInput' >
//                     <label>Company Introduction:</label>
//                     <input type="text" placeholder="$15" value={charges.companyIntroduction} onChange={handleInput} id="companyIntroduction" required/>
//                 </div>

//                 <div className='formInput' >
//                     <label>Self Introduction:</label>
//                     <input type="text" placeholder="$15" value={charges.selfIntroduction}  onChange={handleInput} id="selfIntroduction" required/>
//                  </div>

//                  <div className='formInput' >
//                     <label>Leave Approval:</label>
//                     <input type="text" placeholder="$15" value={charges.leaveApproval}  onChange={handleInput} id="leaveApproval" required/>
//                 </div>

//                 <div className='formInput' >
//                     <label>Employment Letter:</label>
//                     <input type="text" placeholder="$15" value={charges.employmentLetter}  onChange={handleInput} id="employmentLetter" required/>
//                  </div>

//                  <div className='formInput' >
//                     <label>Visa Processing Fee:</label>
//                     <input type="text" placeholder="$15" value={charges.visaProcessingFee}  onChange={handleInput} id="visaProcessingFee" required/>
//                 </div>

//              <button type='submit'>
//               {isloading && <span>...</span>}
//               {isloading ? <span>loading</span> : <span>Submit</span>}

              
//              </button>
//             </form>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Edit
